import { responsive } from "@/lib/media";

/** Thumbnails for a published/pending review's photos. `onOpen(i)` opens a lightbox; otherwise opens the file in a new tab. */
export function ReviewPhotoStrip({ id, photos = [], onOpen, size = "w-16 h-16" }) {
  if (!photos.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid={`review-photos-${id}`}>
      {photos.map((src, i) => {
        const img = <img {...responsive(src, "96px")} alt="Customer photo of the finished job" loading="lazy" className="w-full h-full object-cover" />;
        const cls = `${size} rounded-lg overflow-hidden border border-slate-700 bg-slate-900 block`;
        return onOpen
          ? <button key={src} type="button" onClick={() => onOpen(i)} className={`${cls} transition-transform hover:scale-[1.03]`} aria-label="Open photo" data-testid={`review-photo-${id}-${i}`}>{img}</button>
          : <a key={src} href={src} target="_blank" rel="noreferrer" className={cls} data-testid={`review-photo-${id}-${i}`}>{img}</a>;
      })}
    </div>
  );
}
